import { render, staticRenderFns } from "./BtnLink.vue?vue&type=template&id=402a3395&"
import script from "./BtnLink.vue?vue&type=script&lang=js&"
export * from "./BtnLink.vue?vue&type=script&lang=js&"
import style0 from "./BtnLink.vue?vue&type=style&index=0&id=402a3395&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VCard,VIcon,VListItem,VListItemContent,VListItemIcon,VListItemTitle})
